import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { approveOrder, rejectOrder } from '../actions'

const mapStateToProps = state => {
  return {
    isApproveOrderLoading: state.isApproveOrderLoading,
    hasApproveOrderFailed: state.hasApproveOrderFailed,
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  approveOrder,
  rejectOrder,
}, dispatch)

class OrderApprovalForm extends React.Component {
  render() {
    const { order, isApproveOrderLoading, hasApproveOrderFailed } = this.props
    const { i18n_scope, i18n_params } = order
    return (
      <div>
        {hasApproveOrderFailed && (
          <div className="alert alert-danger">
            {I18n.tt(`fe.NewOrderView.approve_order_failed`, i18n_params)}
          </div>
        )}

        {isApproveOrderLoading && (
          <div>
            <a className="btn btn-primary btn-lg">
              <i className="fa fa-spin fa-circle-o-notch"></i>
            </a>
          </div>
        )}

        {!isApproveOrderLoading && (
          <div>
            <a onClick={() => this.props.approveOrder()} className="btn btn-success btn-lg u-marginRight u-marginBottom" target="_blank">
              {I18n.tt(`fe.NewOrderView.approve_order`, i18n_params)}
            </a>

            <a onClick={() => this.props.rejectOrder()} className="btn btn-danger btn-lg u-marginBottom" target="_blank">
              {I18n.tt(`fe.NewOrderView.reject_order`, i18n_params)}
            </a>
          </div>
        )}
      </div>
    )
  }
}

const ConnectedOrderApprovalForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderApprovalForm)

export default ConnectedOrderApprovalForm



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/containers/OrderApprovalForm.jsx